import { useMemo } from 'react';
import { useLingui } from '@lingui/react';
import { resolveI18nTree } from '../util/i18nTree';
import classnames from '../util/classnames';

const linkClassName = 'text-sm text-primary underline-offset-2 hover:underline cursor-pointer bg-transparent border-0 p-0';

function GoToLink({ link, formFieldsByPath, navigateToField }) {
  const { type, text, url, fieldPath, highlightColor, 'ui:classNames': className } = link;

  if (type === 'external') {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className={classnames(linkClassName, className)}>
        {text}
      </a>
    );
  }

  if (type === 'field') {
    const field = formFieldsByPath?.[fieldPath];
    if (!field) return null;
    return (
      <button type="button" onClick={() => navigateToField?.(field.id, highlightColor || 'primary')} className={classnames(linkClassName, className)}>
        {text}
      </button>
    );
  }

  return null;
}

function FormGoToLinks({ goToLinks, formFieldsByPath, navigateToField }) {
  const { i18n } = useLingui();
  const resolved = useMemo(() => resolveI18nTree(goToLinks, i18n.locale), [goToLinks, i18n.locale]);

  if (!resolved) return null;

  const { 'ui:classNames': barClassName = '', links = [] } = resolved;

  if (!links.length) return null;

  return (
    <div className={classnames('bg-white flex gap-4 items-center flex-wrap justify-center pt-2', barClassName || undefined)}>
      {links.map((link, i) => (
        <GoToLink key={i} link={link} formFieldsByPath={formFieldsByPath} navigateToField={navigateToField} />
      ))}
    </div>
  );
}

export default FormGoToLinks;
